import { PatchType } from 'utility/types/dataProvider';
import { TBatchImportUploadPresetsForm } from '../components/BatchImportUploadPresets';

/**
 * Forms the patch operations payload for NxtImportContext -> dataProvider.binaryConvert().
 * @param presets - The batch import upload presets form data.
 * @returns Array of patch operations (TPatchOperation).
 */
export function createPatchOperationsPayload(
  presets: TBatchImportUploadPresetsForm,
): Array<PatchType> {
  // Get form values for applying to the asset conversion.
  const formValues = presets;

  // Build patch operations array.
  const patchOperations: Array<PatchType> = [];

  // Handle Draft and Publish statuses.
  // Defaults to draft (draft = true, published = false).
  let publishValue: boolean = false;
  let draftValue: boolean = true;
  if (formValues.publish_status && formValues.publish_status.length > 0) {
    const publishStatus: string = formValues.publish_status;

    switch (publishStatus) {
      case 'published':
        publishValue = true;
        draftValue = false;
        break;
      case 'unpublished':
        publishValue = false;
        draftValue = false;
        break;
      case 'draft':
        publishValue = false;
        draftValue = true;
        break;
      // start_time not in presets form currently, so scheduled case not needed.
      default:
        publishValue = false;
        draftValue = true;
    }

    patchOperations.push({
      path: '/published',
      op: 'add',
      value: publishValue,
    });
  }

  // Draft status: always add draft status.
  patchOperations.push({
    path: '/draft',
    op: 'add',
    value: draftValue,
  });

  // Authors.
  if (formValues.authors && formValues.authors.length > 0) {
    patchOperations.push({
      path: '/authors',
      op: 'add',
      value: formValues.authors as string[],
    });
  }

  // Keywords.
  if (formValues.keywords && formValues.keywords.length > 0) {
    patchOperations.push({
      path: '/keywords',
      op: 'add',
      value: formValues.keywords,
    });
  }

  // Sections.
  if (formValues.sections && formValues.sections.length > 0) {
    patchOperations.push({
      path: '/sections',
      op: 'add',
      value: formValues.sections,
    });
  }

  // Workflow ID.
  if (formValues.workflow_id) {
    patchOperations.push({
      path: '/properties/workflow_id',
      op: 'add',
      value: formValues.workflow_id,
    });
  }

  // Print Slug.
  if (formValues.slug) {
    patchOperations.push({
      path: '/properties/print_slug',
      op: 'add',
      value: formValues.slug,
    });
  }

  return patchOperations;
}

export function getIsBpmFile(file: File): boolean {
  return file.name.toLowerCase().endsWith('.bpm');
}
